import { Typography } from "@mui/material";
import type {
  CustomContentProps,
  OptionsObject,
  VariantOverrides,
} from "notistack";
import type { ForwardedRef } from "react";

import { Column } from "../layout";

import * as sx from "./index.sx";

export function StructuredContent({
  body,
  icon,
  ref,
  title,
  ...rest
}: CustomContentProps &
  VariantOverrides["structured"] & { ref: ForwardedRef<HTMLDivElement> }) {
  return (
    <sx.StyledContent
      {...rest}
      ref={ref}
      iconVariant={{ [rest.variant]: icon }}
      message={
        <Column>
          {typeof title === "string" ? (
            <Typography variant="subtitle1">{title}</Typography>
          ) : (
            title
          )}
          {typeof body === "string" ? (
            <Typography variant="body1">{body}</Typography>
          ) : (
            body
          )}
        </Column>
      }
    />
  );
}

export const getStructuredSnackbarOptions = (
  options: Omit<Partial<OptionsObject>, "variant"> &
    VariantOverrides["structured"],
) =>
  ({
    preventDuplicate: true,
    ...options,
    variant: "structured",
  }) as const;
